import YearPanel from '@components/ui/date-time/components/year-panel';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@icon';
import { CalendarYear } from '@rehookify/datepicker';
import React from 'react';
import IconButton from '../../../../icon-button';
import CalendarHeader from '../../../components/calendar-header';
import { TPropsGetters } from '../../../date-time.types';
import { TPanelMode } from '../../../date-time.utils';

interface DatePickerYearsProps {
  mode?: TPanelMode;
  setPanelMode: React.Dispatch<React.SetStateAction<TPanelMode>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onChange?: (dates: Date[]) => void;
  propGetters: TPropsGetters;
  years: CalendarYear[];
}

const DatePickerYears: React.FunctionComponent<DatePickerYearsProps> = ({
  setOpen,
  setPanelMode,
  mode,
  onChange,
  propGetters,
  years,
}) => {
  return (
    <div>
      <CalendarHeader
        left={
          <IconButton
            Icon={ArrowLeftOutlined}
            size="small"
            variant="ghost-tertiary"
            {...propGetters.previousYearsButton()}
          />
        }
        right={
          <IconButton
            Icon={ArrowRightOutlined}
            size="small"
            variant="ghost-tertiary"
            {...propGetters.nextYearsButton()}
          />
        }
      >
        {years[0].value}-{years[years.length - 1].value}
      </CalendarHeader>
      <YearPanel
        yearButton={propGetters.yearButton}
        years={years}
        config={{
          onClick: (_, d) => {
            if (mode === 'date') {
              setPanelMode('date');
            } else if (mode === 'year') {
              if (d) {
                onChange?.([d]);
              }

              setOpen(false);
            } else {
              setPanelMode(mode ?? 'date');
            }
          },
        }}
      />
    </div>
  );
};

export default DatePickerYears;
